import React from "react";
import "./styles.css";
import { formatDuration } from "../../utils/videoHelpers";

const VideoThumbnail = ({ video, isActive, onClick }) => {
  return (
    <div
      className={`video-thumbnail ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      {video.thumbnail ? (
        <img
          src={video.thumbnail}
          alt={`Thumbnail for ${video.name}`}
          className="thumbnail-image"
          loading="lazy"
        />
      ) : (
        <div className="thumbnail-placeholder">
          <i className="fas fa-film"></i>
        </div>
      )}
      <div className="video-info">
        <span className="video-name">{video.name}</span>
        <span className="video-duration">{formatDuration(video.duration)}</span>
      </div>
    </div>
  );
};

export default VideoThumbnail;
